<script>
    import Alert from './componentes/Alert.svelte';
    import Helper from './components/Helper.svelte';
	import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';
	import Titlesection from './components/Titlesection.svelte';
	import AnimationContainer from './components/AnimationContainer.svelte';
	import Navbar from './components/Navbar.svelte';
    import { push } from 'svelte-spa-router';
    import { urlapi, permisos, permisos_struct,permisos_title,miPermiso,iduser,login } from './stores/store';
    import { object2array, postData, isJson, mergeDeep, moneda, verifyAccess } from './scripts';
    import moment from 'moment'

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.configglobal.access===false ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    // status
    let disabled=false;
    let helper=false

    let existecia_ignorar=true;
    let aplicar_descuento=true;
    let myTimeout=null;

    let load=function() {
        disabled=true;
        postData($urlapi, [{ 'cmd':'globales_getOptions' }])
        .then(data => {
            existecia_ignorar=data[0].result.existecia_ignorar;
            aplicar_descuento=data[0].result.aplicar_descuento;
            disabled=false;
        });
    }

    let salir=function() {
        push('/config')
    }

    let change=function() {
        disabled=true;
        save();            

    }

    let save=function() {
        postData($urlapi, [{ 'cmd':'globales_saveOptions','existecia_ignorar':existecia_ignorar,'aplicar_descuento':aplicar_descuento }])
        .then(data => {
            disabled=false;
        });
    }

    load();

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer marginTop=0>
    <Titlesection>
        <span slot="title"><i class="bi bi-gear me-1" />Configuraciones Globales</span>
        <span slot="toolbar">
            <span on:mouseenter={()=>helper='Salir'} on:mouseleave={()=>helper=false}>
                <button disabled={disabled} class="btn btn-warning btn-sm" on:click={salir}><i class="bi bi-box-arrow-in-left"></i></button>
            </span>
        </span>
    </Titlesection>
    
    <br/>

    <div class="row">
        <div class="col-12 col-md-6">

            <h6 class='fw-bold text-uppercase text-warning'>OPCIONES</h6>
            <div class="form-check form-switch border-bottom pb-2 pt-2">
                <input bind:checked={existecia_ignorar} on:change={change} disabled={disabled} class="form-check-input" type="checkbox" id="check_existecia_ignorar">
                <label class="form-check-label" for="check_existecia_ignorar">Permitir facturar productos sin existencia</label>
            </div>

            <div class="form-check form-switch  pb-2 pt-2">
                <input bind:checked={aplicar_descuento} on:change={change} disabled={disabled} class="form-check-input" type="checkbox" id="check_aplicar_descuento">
                <label class="form-check-label" for="check_aplicar_descuento">Permitir aplicar descuento a las facturas</label>
            </div>

        </div>
        <div class="col-12 col-md-6">

        </div>
    </div>
    <Helper bind:text={helper}></Helper>
</AnimationContainer>
{/if}

<style>

</style>